import filtersAction from "./filter";

export default {
  getOverviewDataForSafe({ commit, dispatch }, query) {
    if (!query) return
    return dispatch(
      "get",
      {
        url: "/safe/" + query.provider + "/overview",
      },
      {
        root: true,
      }
    ).then((data) => {
      if (Object.keys(data.site).length === 0) {
        commit("setIsProviderExists", false);
        return;
      }

      commit("setAppointmentsData", data.schedule);
      commit("setProvidersData", data.site);
      commit("setPatientsTags", data.tag);
    });
  },

  getOverviewDataForProvider({ commit, dispatch }, query) {
    if (!query) return
    return dispatch(
      "get",
      {
        url: "/provider/" + query.provider + "/overview",
      },
      {
        root: true,
      }
    ).then((data) => {
      if (Object.keys(data.site).length === 0) {
        commit("setIsProviderExists", false);
        return;
      }

      commit("setAppointmentsData", data.schedule);
      commit("setProvidersData", data.site);
      commit("setPatientsTags", data.tag);
    });
  },

  changeActiveProvider({ commit }, provider) {
    commit("setSelectedProvider", provider);
  },
  changePatientTableData({ commit }, data) {
    const patientsList = data.reduce((acc, val) => {
      return acc.concat(val.patient);
    }, []);
    commit("setpatientsTableDataForSafe", patientsList);
    commit("setpatientsTableDataForProvider", patientsList);
    commit("setOriginalTableData", data);
  },
  ...filtersAction,
};
